import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';

import { HideDirective } from '../../../directives/hide.directive';

@Component({
  selector: 'app-list-navigation',
  templateUrl: './list-navigation.component.html',
  styleUrls: ['./list-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioTooltipDirective, TranslatePipe, HideDirective]
})
export class ListNavigationComponent {
  readonly navConfig = input<any[]>(undefined);
  readonly totals = input<number[]>(undefined);
  readonly selectedNav = input<string>(undefined);
  readonly disabled = input<boolean>(undefined);
  readonly medium = input<boolean>(undefined);

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  readonly onNavSelect = output<any>();

  navSelect(tab: any) {
    if (this.disabled() || tab.disabled) return;

    this.onNavSelect.emit(tab.value);
  }
}
